module.exports = __webpack_public_path__ + "img/card_img_seven.632a555a.png";